export const SET_MODULE_PROGRESS_FOR_COURSE = 'SET_MODULE_PROGRESS_FOR_COURSE';
export const START_FETCH_MODULE_PROGRESS_FOR_COURSE =
  'START_FETCH_MODULE_PROGRESS_FOR_COURSE';
